import { render, staticRenderFns } from "./FrzCtnSelectionGreen.vue?vue&type=template&id=18ac4d1e"
import script from "./FrzCtnSelectionGreen.vue?vue&type=script&lang=js"
export * from "./FrzCtnSelectionGreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports